import React from 'react'
import { NavLinkProps } from 'react-router-dom'
import { Icon, IconType } from '../Icon'
import { colors } from '../colors'
import {
  SidebarNavLink,
  SidebarItemContainer,
  SidebarItemIcon,
  SidebarItemText
} from './SidebarItemLink.styles'

type AllowedNavLinkProps = Pick<
  NavLinkProps,
  | 'to'
  | 'end'
  | 'replace'
  | 'state'
  | 'target'
  | 'reloadDocument'
  | 'preventScrollReset'
  | 'caseSensitive'
>

interface SidebarItemLinkProps extends AllowedNavLinkProps {
  icon: IconType
  text: string
  className?: string
  collapsed?: boolean
}

export const SidebarItemLink: React.FC<SidebarItemLinkProps> = ({
  icon,
  text,
  collapsed = false,
  className,
  ...navLinkProps
}) => {
  return (
    <SidebarNavLink {...navLinkProps} className={className}>
      {({ isActive }) => (
        <SidebarItemContainer isActive={isActive} $collapsed={collapsed}>
          <SidebarItemIcon $collapsed={collapsed}>
            <Icon type={icon} size={24} color={colors.gray600} />
          </SidebarItemIcon>
          <SidebarItemText isActive={isActive} $collapsed={collapsed}>
            {text}
          </SidebarItemText>
        </SidebarItemContainer>
      )}
    </SidebarNavLink>
  )
}
